import React from "react";
import { useTranslation } from "react-i18next";
import toast from "react-hot-toast";
import { Close } from "@dreamhub/designsystem/icons";
import ToastBody from "@/components/ui/toast-body";
import { StatusBadge } from "@/components/ui/status-badge";
import { getEnumTKey } from "@/utils/strings";
import { IconButton } from "@/components/ui/icon-button";
import { leadStatusColors } from "@/pages/leads/helpers";
import { LeadStatus } from "@/pages/leads/types";

interface Props {}

const MarkLeadAsICPToast: React.FC<Props> = ({}) => {
  const { t } = useTranslation();
  const valueKey = getEnumTKey(
    "leads",
    "statusValues",
    LeadStatus,
    LeadStatus.IN_PROGRESS
  );

  return (
    <ToastBody
      title={t("leads.leadView.confirmedAsICPToast")}
      subtitle={
        <>
          {t("leads.leadView.statusUpdated")}
          <span className="inline-block align-text-top px-2 -translate-y-1">
            <StatusBadge
              statusColor={leadStatusColors[LeadStatus.IN_PROGRESS]}
              className="px-1 py-[2px] text-primary"
            >
              {t(valueKey)}
            </StatusBadge>
          </span>
          {t("leads.leadView.turnToDeal")}
        </>
      }
      actions={
        <IconButton
          size="md"
          variant="iconNoBg"
          iconColor="secondary"
          onClick={() => toast.dismiss()}
        >
          <Close />
        </IconButton>
      }
    />
  );
};

export default MarkLeadAsICPToast;
